export const emptyAsset = { key: "", url: "", mimeType: "", size: 0 };

export const guessMimeFromExt = (ext) => {
  const e = String(ext || "").toLowerCase();
  if (e === "png") return "image/png";
  if (e === "jpg" || e === "jpeg") return "image/jpeg";
  if (e === "webp") return "image/webp";
  if (e === "gif") return "image/gif";
  if (e === "svg") return "image/svg+xml";
  if (e === "bmp") return "image/bmp";
  if (e === "heic") return "image/heic";
  return "";
};

export const getEmptySettings = () => ({
  // Global settings
  siteName: "",
  siteUrl: "",
  hotline: "",
  email: "",
  address: "",
  contactPersonName: "",
  
  // Assets
  logo: { ...emptyAsset },
  favicon: { ...emptyAsset },
  ogImage: { ...emptyAsset },
  background: { ...emptyAsset },
  
  // Social media
  facebook: "",
  instagram: "",
  tiktok: "",
  youtube: "",
  
  // Global SEO
  seo: {
    defaultTitle: "",
    defaultDescription: "",
    defaultKeywords: [],
    organization: {
      name: "",
      url: "",
      logo: "",
      sameAs: [],
    },
  },
  
  // About Page
  aboutPage: {
    seo: {
      title: "",
      description: "",
      keywords: [],
      url: "",
      organization: { name: "", url: "", logo: "", sameAs: [] },
    },
    hero: {
      title: "",
      subtitle: "",
      background: { ...emptyAsset },
      kicker: "",
      primaryButtonLabel: "",
      primaryButtonTo: "",
      secondaryButtonLabel: "",
      secondaryButtonTo: "",
    },
    stats: [],
    storySection: {
      kicker: "",
      title: "",
      story: "",
      image: { url: "", alt: "" },
      locationBadgeTitle: "",
      locationBadgeDesc: "",
      checklist: [],
    },
    valuesSection: { kicker: "", title: "" },
    values: [],
    timelineSection: { kicker: "", title: "" },
    timeline: [],
    teamSection: { kicker: "", title: "" },
    team: [],
    testimonialsSection: { kicker: "", title: "" },
    testimonials: [],
    missionCta: {
      kicker: "",
      title: "",
      desc: "",
      primaryLabel: "",
      primaryTo: "",
      secondaryLabel: "",
      secondaryTo: "",
    },
  },

  // Areas Page
});
